module.exports = __webpack_public_path__ + "static/media/highlight.9efec145.jpg";